import styled from "styled-components";

export const FavoriteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 1rem;
  text-align: center;
  margin: 14px 50px;
`;

export const FavoriteTitle = styled.h1`
  font-size: 2.5rem;
  color: #616161;
`;

export const FavoriteImg = styled.img`
  width: 40px;
  margin: 0 10px;
`;

export const FavoriteMessage = styled.p`
  font-size: 3rem;
  color: #b71c1c;
  margin: 50px;
`;
